import { AdminActionButton } from '../admin-action-button';
import { AdminActionButtonItem } from '../admin-action-button-item';
import { AdminPlacePanelActionButtonProps } from './admin-place-panel-action-button-props';
import React from 'react';
import { useAdminPlacePanelController } from './use-admin-place-panel-controller';

export const AdminPlacePanelActionButton: React.FunctionComponent<
  AdminPlacePanelActionButtonProps
> = props => {
  const {
    editingPlace,
    onSaveClick,
    onDiscardClick,
  } = useAdminPlacePanelController(props.placeKey);

  const createLabel = editingPlace ? 'Update Place' : 'Create Place';

  return (
    <AdminActionButton label={createLabel} onClick={onSaveClick}>
      <AdminActionButtonItem onClick={onSaveClick}>
        {createLabel}
      </AdminActionButtonItem>
      <AdminActionButtonItem color="danger" onClick={onDiscardClick}>
        {editingPlace ? 'Discard Changes' : 'Discard Place'}
      </AdminActionButtonItem>
    </AdminActionButton>
  );
};
